import React  from 'react'
import { useDispatch } from 'react-redux'
import styled from 'styled-components'
import { setViewBulletinFile  } from 'features/bulletin/bulletinSlice' 
import { Tooltip } from '@mui/material';
import { RxDownload } from "react-icons/rx";  
import OpenInFullIcon from '@mui/icons-material/OpenInFull'; 
import { TiDocumentText } from "react-icons/ti";

export default function BulletinItem2(props) {

    const dispatch = useDispatch()  
    const handleView = () => {
        dispatch(setViewBulletinFile(props.data.path))
    } 
    const handleDownloadBulletin = async () => {

        let bulletinUrl = `${props.data.path}`

        fetch(bulletinUrl).then(response => {
            response.blob().then((blob) => {  
                const fileURL = window.URL.createObjectURL(blob); 
                let alink = document.createElement("a");
                alink.href = fileURL;
                alink.download = props.data.fileName;
                alink.click();
            });
        })

    }


    return (

        <BulletinItemContainer  >
                <section onClick={handleView}>
                    <AISection >
                        <TiDocumentText size={40} style={{ marginRight: '10px' }} />
                        <div>{props.data.fileName}</div>                 
                    </AISection> 
                </section>

                <AISection>
                    <Tooltip title="View" placement='top'>
                        <IconButton
                            onClick={handleView}
                            >
                            <OpenInFullIcon />
                        </IconButton>
                    </Tooltip>

                    <Tooltip title="Download" placement='top'>
                        <IconButton
                            onClick={handleDownloadBulletin}
                            download
                            >
                            <RxDownload style={{backgroundColor: 'inherit'}} />
                        </IconButton>
                    </Tooltip>  
                </AISection>  
        </BulletinItemContainer>
    )
}
 

const IconButton = styled.button`
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 12px;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    outline: none; 
    border: none;
    svg{
        font-size: 20px;
        color: var(--lightThemeFontColor);
        background-color: inherit;
    }
    &:hover{
        transition: all 0.5s; 
        background-color: #dfdfdf;
    }
`

const AISection = styled.span`
    position: relative;
    padding: 0 10px; 
    display: flex; 
    flex-direction: row;
    align-items: center;
    justify-content: center;

` 

const BulletinItemContainer = styled.div`
    color: var(--lightThemeFontColor);
    width: 100%;
    height: 75px;
    display: flex;
    align-items: center;
    justify-content: space-between; 
    margin: 5px 0;
    background-color: #ffffff;
    border-radius: 11px;
    box-shadow: 0px 0px 5px #ccc;
    border: 1px solid #dfdfdf;

    section{
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
    }

    &:hover{
        cursor: pointer;    
        border: 1px solid #ccc;
    }


` 